import { HomeMobileOffer } from "../HomeMobileOffer/HomeMobileOffer";
import { HandleErrorAndLoading } from "@common/HandleErrorAndLoading/HandleErrorAndLoading";
import { HomeBroadbandSidePanel } from "@features/home/mobile/HomeBroadbandSidePanel/HomeBroadbandSidePanel";
import { useStyle } from "@features/home/mobile/HomeMobile/style";
import mobilePlan from "@static/img/home/mobileOffer.png";
import mobilePlanCrop from "@static/img/home/mobileOfferCrop.png";
import { useDeviceType } from "@hooks/useDeviceType";
import { Stack } from "@mui/material";
import { useTranslation } from "react-i18next";
import { ICartOffer, ICatalogOffer } from "@features/cart/ICart";
import { IError, IFetchState } from "itsf-ui-common";
import { IEirSalesPrequal } from "@modules/eirSalesFacade/interfaces/models/IEirSalesPrequal";
import { OrderAuthorizationEnum } from "@utils/getOrderAuthorization";

interface IParams {
    broadbandOffer?: ICatalogOffer;
    mobileOffer?: ICatalogOffer;
    broadbandCartOffer?: ICartOffer;
    hasMobileOfferInCart: boolean;
    mobileOfferCount: number;
    hasBroadbandOfferInCart: boolean;
    isBroadbandSidePanelOpen: boolean;
    closeBroadbandSidePanel(): void;
    isLoading: boolean;
    error?: IError;
    orderAuthorization?: OrderAuthorizationEnum;
    handleAddMobileOffer(selectedOffer: ICatalogOffer): void;
    handleAddBroadbandOffer(selectedOffer: ICatalogOffer, prequal: IEirSalesPrequal): void;
    handleDeleteBroadbandOffer(): void;
    addBroadbandOfferState: IFetchState;
    retry(): void;
}

export const HomeMobile = (props: IParams) => {
    const {
        broadbandOffer,
        mobileOffer,
        broadbandCartOffer,
        hasMobileOfferInCart,
        mobileOfferCount,
        hasBroadbandOfferInCart,
        isBroadbandSidePanelOpen,
        closeBroadbandSidePanel,
        isLoading,
        error,
        orderAuthorization,
        handleAddMobileOffer,
        handleAddBroadbandOffer,
        handleDeleteBroadbandOffer,
        addBroadbandOfferState,
        retry,
    } = props;
    const { isMobile } = useDeviceType();

    const { classes } = useStyle();

    const { t } = useTranslation("home");

    return (
        <Stack gap={1}>
            <div className={classes.offerHome}>
                <div className={classes.offerHomeContent}>
                    <HandleErrorAndLoading error={error} isHomePage isLoading={isLoading} retryFetch={retry}>
                        <>
                            {broadbandOffer && (
                                <HomeBroadbandSidePanel
                                    addBroadbandOfferState={addBroadbandOfferState}
                                    broadbandCartOffer={broadbandCartOffer}
                                    handleAddBroadbandOffer={handleAddBroadbandOffer}
                                    handleDeleteBroadbandOffer={handleDeleteBroadbandOffer}
                                    hasBroadbandOfferInCart={hasBroadbandOfferInCart}
                                    isOpen={isBroadbandSidePanelOpen}
                                    offer={broadbandOffer}
                                    onClose={closeBroadbandSidePanel}
                                />
                            )}
                            {mobileOffer && (
                                <HomeMobileOffer
                                    handleAddMobileOffer={handleAddMobileOffer}
                                    hasMobileOfferInCart={hasMobileOfferInCart}
                                    mobileOfferCount={mobileOfferCount}
                                    offer={mobileOffer}
                                    orderAuthorization={orderAuthorization}
                                />
                            )}
                        </>
                    </HandleErrorAndLoading>
                </div>
                {!isMobile && (
                    <div className={classes.offerHomeImage}>
                        <img alt={t("mobilePlan.imageAlt")} className={classes.desktopImage} src={mobilePlan} />
                    </div>
                )}
            </div>
            {isMobile && <img alt={t("mobilePlan.imageAlt")} className={classes.mobileImage} src={mobilePlanCrop} />}
        </Stack>
    );
};
